'use client';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';
gsap.registerPlugin(ScrollTrigger);

const StickyButton = ({ link, img, svg, text, position, classCustom }) => {
  return (
    <StyledBtn
      position={position}
      className={`dc-btn showSticky ${classCustom ? classCustom : ''}`}>
      <Link
        id="imSticky"
        data-magnetism
        target={'_blank'}
        href={link ? `https://wa.me/${link}` : 'https://wa.me/+8801770000000'}>
        {svg ? (
          <div
            dangerouslySetInnerHTML={{ __html: svg }}
            style={{ display: 'inline-block', lineHeight: 0 }}
          />
        ) : img ? (
          <img src={img} alt={text} />
        ) : null}
      </Link>
    </StyledBtn>
  );
};

const StyledBtn = styled.div`
  position: fixed;
  right: 50px;
  bottom: ${props => props.position || '30px'};
  z-index: 999;
  transition: 0.7s all ease;
  @media (max-width: 992px) {
    transform: scale(1) !important;
  }
  @media (max-width: 767px) {
    right: 15px;
    bottom: 15px;
  }
  a {
    .hover_stik {
      transition: 0.7s all ease;
    }

    &:hover {
      .hover_stik {
        /* SVG animation handled by CSS custom properties or GSAP */
        transform: scale(1.2);
      }
    }
  }
`;

export default React.memo(StickyButton);
